import { useMutation } from "@apollo/client";
import { SlateEditor } from "@govlaunch/editor";
import React from "react";
import SubscribeForNewsletterFromStory from "../graphql/SubscribeForNewsletterFromStory";
import {
  ISubscribeForNewsletterFromStoryMutation,
  ISubscribeForNewsletterFromStoryMutationVariables,
} from "../graphql/__generated__/SubscribeForNewsletterFromStory.generated";

interface IStoryPageSummaryProps {
  body: any;
}

export default function StoryPageSummary({ body }: IStoryPageSummaryProps) {
  const [subscribe] = useMutation<
    ISubscribeForNewsletterFromStoryMutation,
    ISubscribeForNewsletterFromStoryMutationVariables
  >(SubscribeForNewsletterFromStory);

  return (
    <SlateEditor
      value={body}
      onChange={() => {}}
      minContentHeight={300}
      readOnly={true}
      placeholder="This is where you can give more information about your project or initiative..."
      onEmailSubscribe={async (email: string) => {
        const result = await subscribe({
          variables: {
            email,
          },
        });

        if (result && result.data && result.data.subscribeForNewsletterFromStory) {
          return true;
        } else {
          return false;
        }
      }}
    />
  );
}
